module.exports = __webpack_public_path__ + "static/img/1.9b0a514.png";


//////////////////
// WEBPACK FOOTER
// ./static/banner2/1.png
// module id = JT7L
// module chunks = 14